export class UserLeadAssignmentRule {
  #http;

  constructor(http) {
    this.#http = http;
  }

  getInternalRule = async ({ userId }) => {
    return this.#http.get(`/UserLeadAssignmentRule/internal/${userId}`);
  };

  getRule = async ({ userId }) => {
    return this.#http.get(`/UserLeadAssignmentRule/${userId}`);
  };

  createInternalRule = async body => {
    return this.#http.post('/UserLeadAssignmentRule/internal', body);
  };

  createRule = async body => {
    return this.#http.post('/UserLeadAssignmentRule', body);
  };

  editInternalRule = async body => {
    return this.#http.put('/UserLeadAssignmentRule/internal', body);
  };

  editRule = async body => {
    return this.#http.put('/UserLeadAssignmentRule', body);
  };

  deleteInternalRule = async params => {
    return this.#http.delete('/UserLeadAssignmentRule/internal', { params });
  };

  deleteRule = async params => {
    return this.#http.delete('/UserLeadAssignmentRule', { params });
  };
}
